"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRunWithAmplifyServerContext = void 0;
const utils_1 = require("aws-amplify/utils");
const adapter_core_1 = require("aws-amplify/adapter-core");
const constant_1 = require("../auth/constant");
const createCookieStorageAdapterFromNextServerContext_1 = require("./createCookieStorageAdapterFromNextServerContext");
const createRunWithAmplifyServerContext = ({ config: resourcesConfig, tokenValidator, globalSettings, }) => {
    const isServerSideAuthEnabled = globalSettings.isServerSideAuthEnabled();
    const isSSLOrigin = globalSettings.isSSLOrigin();
    const setCookieOptions = globalSettings.getRuntimeOptions().cookies ?? {};
    const mergedSetCookieOptions = {
        // default options when not specified
        ...(isServerSideAuthEnabled && constant_1.DEFAULT_SERVER_SIDE_AUTH_SET_COOKIE_OPTIONS),
        // user-specified options
        ...setCookieOptions,
        // enforced options when server-side auth is enabled
        ...(isServerSideAuthEnabled && {
            ...constant_1.ENFORCED_SERVER_SIDE_AUTH_SET_COOKIE_OPTIONS,
            secure: isSSLOrigin,
        }),
        // only support root path
        path: '/',
    };
    const runWithAmplifyServerContext = async ({ nextServerContext, operation }) => {
        // When the Auth config is presented, attempt to create a Amplify server
        // context with token and credentials provider.
        if (resourcesConfig.Auth) {
            const keyValueStorage = 
            // When `null` is passed as the value of `nextServerContext`, opt-in
            // unauthenticated role (primarily for static rendering). It's
            // safe to use the singleton `MemoryKeyValueStorage` here, as the
            // static rendering uses the same unauthenticated role cross-sever.
            nextServerContext === null
                ? utils_1.sharedInMemoryStorage
                : (0, adapter_core_1.createKeyValueStorageFromCookieStorageAdapter)(await (0, createCookieStorageAdapterFromNextServerContext_1.createCookieStorageAdapterFromNextServerContext)(nextServerContext, isServerSideAuthEnabled), tokenValidator, mergedSetCookieOptions);
            const credentialsProvider = (0, adapter_core_1.createAWSCredentialsAndIdentityIdProvider)(resourcesConfig.Auth, keyValueStorage);
            const tokenProvider = (0, adapter_core_1.createUserPoolsTokenProvider)(resourcesConfig.Auth, keyValueStorage);
            return (0, adapter_core_1.runWithAmplifyServerContext)(resourcesConfig, {
                Auth: { credentialsProvider, tokenProvider },
            }, operation);
        }
        // Otherwise it may be the case that auth is not used, e.g. API key.
        // Omitting the `Auth` in the second parameter.
        return (0, adapter_core_1.runWithAmplifyServerContext)(resourcesConfig, {}, operation);
    };
    return runWithAmplifyServerContext;
};
exports.createRunWithAmplifyServerContext = createRunWithAmplifyServerContext;
